import { useState } from "react";
import { createSessionClient } from "../api/client";

// Public VAPID key — safe to ship to the client.
const VAPID_PUBLIC_KEY = "BPYNKUd0tnHBvxngR_xHHdhqNbr9cCg4m1GObkmWaf_nrBcM8Ix_iNcOy8lX0iDllaFWC7NNLiGQenOw4s1kfPk";

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const normalized = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(normalized);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

const supported =
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator &&
  typeof window !== "undefined" &&
  "PushManager" in window &&
  "Notification" in window;

/** Lets a magic-link member turn on Web Push so they get the decision/reminder even with the tab closed. */
const EnableNotifications: React.FC<{ token: string }> = ({ token }) => {
  const [state, setState] = useState<"idle" | "working" | "on" | "denied" | "error">("idle");

  if (!supported) return null;

  const enable = async () => {
    setState("working");
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") {
        setState("denied");
        return;
      }
      const reg = await navigator.serviceWorker.register("/sw.js");
      await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
      const json = sub.toJSON() as { endpoint?: string; keys?: { p256dh?: string; auth?: string } };
      await createSessionClient(token).post("/api/session/push", {
        endpoint: json.endpoint,
        p256dh: json.keys?.p256dh,
        auth: json.keys?.auth,
      });
      setState("on");
    } catch {
      setState("error");
    }
  };

  if (state === "on") {
    return <p className="mt-3 text-xs text-primary-700">🔔 Notifications on — we'll ping you when the plan's set.</p>;
  }
  if (state === "denied") {
    return <p className="mt-3 text-xs text-ink/45">Notifications are blocked — enable them in your browser settings.</p>;
  }
  return (
    <button
      onClick={enable}
      disabled={state === "working"}
      className="mt-3 text-sm font-medium text-dusk-500 underline hover:text-dusk-700 disabled:opacity-50"
    >
      {state === "working" ? "…" : "🔔 Notify me about this plan"}
    </button>
  );
};

export default EnableNotifications;
